module.exports = __webpack_public_path__ + "static/media/tiger.66cf1012.m4a";